module.exports = __webpack_public_path__ + "media/images/wealthbar/dashboard/book-icon-9ee08f0af7daa9ba7db80e9fabcb1bfd.png";